import type { EmailSettings } from "@productlane/zero"
import { buildDnsZoneFile } from "@productlane/lib/src/dns-zone"

// BIND zone file: what Cloudflare's DNS import accepts directly.
export function downloadDnsRecords(address: EmailSettings) {
	const zone = buildDnsZoneFile({
		domain: address.domain,
		records: [
			{
				type: "TXT",
				host: `${address.txtDnsKey}.${address.domain}`,
				value: address.txtDnsValue,
			},
			{
				type: "CNAME",
				host: `${address.cnameDnsKey}.${address.domain}`,
				value: address.cnameDnsValue,
			},
		],
	})
	const blob = new Blob([zone], { type: "text/plain" })
	const url = URL.createObjectURL(blob)
	const link = document.createElement("a")
	link.href = url
	link.download = `${address.domain}-dns.txt`
	link.click()
	URL.revokeObjectURL(url)
}
